import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { TableCell, TableRow } from '@/components/ui/table';

interface ReportsTableSkeletonProps {
  rowCount: number;
  showActions?: boolean;
}

export const ReportsTableSkeleton: React.FC<ReportsTableSkeletonProps> = ({
  rowCount,
  showActions = true,
}) => (
  <>
    {Array.from({ length: rowCount }).map((_, i) => (
      <TableRow key={i}>
        <TableCell className="px-4 py-4 align-middle">
          <Skeleton className="h-5 w-40 inline-block" />
        </TableCell>
        <TableCell className="px-4 py-4 text-center align-middle">
          <Skeleton className="h-5 w-10 inline-block" />
        </TableCell>
        <TableCell className="px-4 py-4 align-middle">
          <Skeleton className="h-5 w-24 inline-block" />
        </TableCell>
        <TableCell className="px-4 py-4 align-middle">
          <Skeleton className="h-5 w-24 inline-block" />
        </TableCell>
        <TableCell className="px-4 py-4 text-center align-middle">
          <Skeleton className="h-6 w-16 rounded-full inline-block" />
        </TableCell>
        <TableCell className="px-4 py-4 text-center align-middle">
          <Skeleton className="h-5 w-8 inline-block" />
        </TableCell>
        <TableCell className="px-4 py-4 text-center align-middle">
          <Skeleton className="h-5 w-8 inline-block" />
        </TableCell>
        <TableCell className="px-4 py-4 text-center align-middle">
          <Skeleton className="h-6 w-28 rounded-full inline-block" />
        </TableCell>
        {showActions ? (
          <TableCell className="px-4 py-4 text-center align-middle">
            <Skeleton className="h-8 w-8 rounded inline-block" />
          </TableCell>
        ) : null}
      </TableRow>
    ))}
  </>
);
